import React, { useEffect, useState, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../components/CheckoutForm";

const stripePromise = loadStripe(
  "pk_test_51R0LkQCAFIyRJjVMJgtv3UmbHnenNVKfy3rPzwXvcymK9CpnSxjT4SzDm2IVhUpT169hNG6m60qmcSdjwMZpC4UK00hgb3QLo6"
);

function PaymentPage() {
  const [searchParams] = useSearchParams();
  const payableId = searchParams.get("payableId");
  const payableType = searchParams.get("payableType");
  const token = localStorage.getItem("authToken");
  
  const [clientSecret, setClientSecret] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // ✅ Prevent duplicate calls
  const initiatedRef = useRef(false);
  const abortControllerRef = useRef(null);

  useEffect(() => {
    if (!payableId || !payableType || !token) return;

    // ✅ Create unique key for this payment
    const paymentKey = `${payableType}-${payableId}`;
    
    // ✅ Prevent duplicate calls
    if (initiatedRef.current === paymentKey || clientSecret) {
      return;
    }

    initiatePayment(paymentKey);
  }, [payableId, payableType, token, clientSecret]);

  // ✅ Cleanup on unmount
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const initiatePayment = async (paymentKey) => {
    if (loading) return; // ✅ Prevent concurrent calls
    
    try {
      setLoading(true);
      setError(null);

      // ✅ Cancel previous request if exists
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }

      // ✅ Create new abort controller
      const abortController = new AbortController();
      abortControllerRef.current = abortController;

      let url = "";
      let body = {};
      
      if (payableType === "Booking") {
        url = "http://localhost:30002/api/v1/payments/initiate";
        body = { id: payableId };
      } else if (payableType === "CarInspection") {
        url = "http://localhost:30002/api/v1/payments/initiate_inspection_payment";
        body = { inspection_id: payableId };
      } else {
        throw new Error(`Unsupported payable type: ${payableType}`);
      }

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(body),
        signal: abortController.signal, // ✅ Add abort signal
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || "Payment initiation failed");
      }

      const data = await response.json();
      
      // ✅ Check if request was aborted
      if (abortController.signal.aborted) {
        return;
      }

      setClientSecret(data.client_secret);
      setPaymentId(data.payment_id);
      initiatedRef.current = paymentKey; // ✅ Mark as initiated
      
      console.log('Payment initiated successfully:', {
        paymentId: data.payment_id,
        amount: data.amount,
        currency: data.currency
      });

    } catch (err) {
      // ✅ Ignore aborted requests
      if (err.name === 'AbortError') {
        return;
      }
      
      console.error("Payment init error:", err.message);
      setError(err.message);
      initiatedRef.current = false; // ✅ Reset on error
    } finally {
      setLoading(false);
      abortControllerRef.current = null;
    }
  };

  const handleRetry = () => {
    initiatedRef.current = false;
    setClientSecret(null);
    setPaymentId(null);
    setError(null);
    const paymentKey = `${payableType}-${payableId}`;
    initiatePayment(paymentKey);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Initializing payment...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
          <div className="text-red-600 text-xl mb-2">⚠️</div>
          <h3 className="text-red-800 font-semibold mb-2">Payment Error</h3>
          <p className="text-red-700 mb-4">{error}</p>
          <button 
            onClick={handleRetry}
            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition-colors"
          >
            Retry Payment
          </button>
        </div>
      </div>
    );
  }

  if (!clientSecret || !paymentId) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <p className="text-gray-600">Loading payment...</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Elements stripe={stripePromise} options={{ clientSecret }}>
        <CheckoutForm
          clientSecret={clientSecret}
          paymentId={paymentId}
          token={token}
        />
      </Elements>
    </div>
  );
}

export default PaymentPage;
// import React, { useEffect, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
// import CheckoutForm from "../components/CheckoutForm";

// const stripePromise = loadStripe(
//   "pk_test_51R0LkQCAFIyRJjVMJgtv3UmbHnenNVKfy3rPzwXvcymK9CpnSxjT4SzDm2IVhUpT169hNG6m60qmcSdjwMZpC4UK00hgb3QLo6"
// );

// function PaymentPage() {
//   const [searchParams] = useSearchParams();
//   const payableId = searchParams.get("payableId");
//   const payableType = searchParams.get("payableType");
//   const token = localStorage.getItem("authToken");

//   const [clientSecret, setClientSecret] = useState(null);
//   const [paymentId, setPaymentId] = useState(null);

//   useEffect(() => {
//     if (!payableId || !payableType || !token) return;

//     let url = "";
//     let body = {};

//     if (payableType === "Booking") {
//       url = "http://localhost:30002/api/v1/payments/initiate";
//       body = { id: payableId };
//     } else if (payableType === "CarInspection") {
//       url = "http://localhost:30002/api/v1/payments/initiate_inspection_payment";
//       body = { inspection_id: payableId };
//     }

//     // ✅ Prevent double-call: only fetch if we don't already have a clientSecret
//     if (clientSecret) return;

//     fetch(url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         "Authorization": `Bearer ${token}`, // ✅ use token from localStorage
//       },
//       body: JSON.stringify(body),
//     })
//       .then((res) => {
//         if (!res.ok) {
//           return res.json().then((err) => {
//             throw new Error(err.error || "Payment initiation failed");
//           });
//         }
//         return res.json();
//       })
//       .then((data) => {
//         setClientSecret(data.client_secret);
//         setPaymentId(data.payment_id);
//       })
//       .catch((err) => {
//         console.error("Payment init error:", err.message);
//         alert(`Payment init failed: ${err.message}`);
//       });
//   }, [payableId, payableType, token, clientSecret]);

//   if (!clientSecret || !paymentId) return <div>Loading payment...</div>;

//   return (
//     <Elements stripe={stripePromise} options={{ clientSecret }}>
//       <CheckoutForm
//         clientSecret={clientSecret}
//         paymentId={paymentId}
//         token={token}
//       />
//     </Elements>
//   );
// }

// export default PaymentPage;
